export const EventsText = {
  logout: {
    loading: 'Logging out...',
  },
}
